import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store/ducks';
import { IDownloadBarProps } from './interface';

import Loading from 'components/Loading';
import Text from 'components/Text';
import Animated from 'components/Animated';

import downloadIcon from 'img/arrow-download.svg';
import closeIcon from 'img/icon-close-dark.svg';

import './styles.scss';

export const DownloadBar: React.FC<IDownloadBarProps> = () => {

  const downloadBar = useSelector((state: RootState) => state.downloadBar);
  const dispatch = useDispatch();

  const [isReadyToDownload, setIsReadyToDownload] = useState(false);
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    setIsReadyToDownload(downloadBar?.url !== undefined);
  }, [downloadBar?.url]);

  useEffect(() => {
    if (downloadBar?.error !== undefined) {
      console.error('downloadBar?.error', downloadBar?.error);
    }
    setHasError(downloadBar?.error !== undefined);
  }, [downloadBar?.error]);

  const handleDownloadExportDate = () => {
    window.open(downloadBar?.url, '_blank');
    dispatch({ type: 'CLOSE_DOWNLOAD_BAR' });
  };

  const handleCloseDownload = () => {
    dispatch({ type: 'CLOSE_DOWNLOAD_BAR' });
  };

  const downloadInProgress = (
    <div className='background-download-bar d-flex align-center justify-center px-sm-2 p-1 relative z-6'>
      <Loading onlySpinner={true} size={20} />
      <Text size={16} className="pl-1 color-blue-gray font-bold">Seus dados estão sendo processados</Text>
      <Text size={16} className="p-1 color-blue-gray font-bold">|</Text>
      <Text size={16} className="color-blue-gray">Você será notificado por e-mail assim que o relatório estiver finalizado.</Text>

      <button
        style={{ width: 18 }}
        onClick={() => handleCloseDownload()}
        className="ml-3 mt-1"
      >
        <img src={closeIcon} style={{ width: 18 }} />
      </button>
    </div>
  );

  const downloadReady = (
    <div className='background-download-bar d-flex align-center justify-center px-sm-2 p-1 relative z-6'>
      <button
        style={{ width: 16 }}
        onClick={() => handleDownloadExportDate()}
        className="mt-1"
      >
        <img src={downloadIcon} style={{ width: 16 }} />
      </button>

      <Text size={16} className="pl-1 color-blue-gray font-bold">Relatório Disponível</Text>
      <Text size={16} className="p-1 color-blue-gray font-bold">|</Text>
      <Text size={16} className="color-blue-gray">Clique aqui para fazer o download dos dados</Text>

      <button
        style={{ width: 18 }}
        onClick={() => handleCloseDownload()}
        className="ml-3 mt-1"
      >
        <img src={closeIcon} style={{ width: 18 }} />
      </button>
    </div>
  );

  const errorBar = (
    <div className='background-download-bar d-flex align-center justify-center px-sm-2 p-1 relative z-6'>
      <Text size={16} className="p-1 color-blue-gray font-bold">Não foi possível gerar o seu relatório.</Text>
      <Text size={16} className="color-blue-gray">Tente novamente mais tarde.</Text>
      
      <button
        style={{ width: 18 }}
        onClick={() => handleCloseDownload()}
        className="ml-3 mt-1"
      >
        <img src={closeIcon} style={{ width: 18 }} />
      </button>
    </div>
  );

  return (
    <>
      <Animated
        animationIn="slideInDown"
        animationInDelay="faster"
        animationOut="slideOutUp"
        animationOutDelay="faster"
        show={!!downloadBar?.show}
      >
        {hasError ? errorBar : isReadyToDownload ? downloadReady : downloadInProgress}
      </Animated>
    </>
  );
};
